/* eslint-disable no-console */
import type { ISbStoriesParams, ISbStoryData } from '@storyblok/vue'
import { STORYBLOK_API_URL, STORYBLOK_DEV_ENVIRONMENTS } from './constants'

export class StoryblokHelper {
  static async getAllStories(accessToken: string, version: string): Promise<ISbStoryData[]> {
    const url = new URL(STORYBLOK_API_URL)
    const params = new URLSearchParams({
      version,
      token: accessToken,
      cv: 'undefined',
    })
    url.search = params.toString()

    console.log('[STORYBLOK] fetching URL:', url.toString())
    const response = await fetch(url)
    const { stories } = (await response.json()) as { stories: ISbStoryData[] }
    return stories
  }

  static getEnvironmentVersion(environment: string): NonNullable<ISbStoriesParams['version']> {
    const isDevEnvironment = STORYBLOK_DEV_ENVIRONMENTS.some((e) => {
      const env = e.toLowerCase()
      return environment.toLocaleLowerCase().includes(env)
    })

    console.log('[STORYBLOK] environment version for', environment, 'is', isDevEnvironment ? 'draft' : 'published')
    return isDevEnvironment ? 'draft' : 'published'
  }

  static getStoryPath(story: ISbStoryData) {
    let path = story.path || story.slug

    if (!path.startsWith('/'))
      path = `/${path}`

    console.log('[STORYBLOK] story path for', story.slug, 'is', path)
    return path
  }
}
